document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.link-color-swatch-grid .more-colors').forEach((button) => {
    button.addEventListener('click', () => {
      button.style.display = 'none';
      button.closest('.link-color-swatch-grid').querySelectorAll('.hidden_variantions').forEach((hiddenColor) => {
        hiddenColor.style.display = 'block';
      });
    });
  });
});